/**
 * @module public/js/utils/runtimeDi.js
 * @summary Resolve the active dependency container without importing app bootstrap.
 */

/**
 * Return an explicit dependency bag or the runtime-global DI container.
 *
 * @param {Record<string, unknown>|null|undefined} services - Optional service overrides.
 * @returns {Record<string, unknown>} Resolved service container.
 */
export function resolveRuntimeDi(services = null) {
  if (services && typeof services === 'object') return services;
  return globalThis?.di && typeof globalThis.di === 'object'
    ? globalThis.di
    : {};
}
